import { render } from "./SelectCollectionVisibility.vue?vue&type=template&id=430c1258&scoped=true"
import script from "./SelectCollectionVisibility.vue?vue&type=script&lang=js"
export * from "./SelectCollectionVisibility.vue?vue&type=script&lang=js"

import "./SelectCollectionVisibility.vue?vue&type=style&index=0&id=430c1258&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430c1258"]])

export default __exports__